import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { api } from '@/api/client'

interface VisitorSession {
  access_token: string
  expires_in: number
  client_id: string
  full_name: string
  organization: { id: string; name: string; slug: string }
}

const TOKEN_KEY = 'fitness_visitor_token'

export const usePortalStore = defineStore('portal', () => {
  const token = ref(localStorage.getItem(TOKEN_KEY) || '')
  const session = ref<VisitorSession | null>(null)
  const isAuthenticated = computed(() => Boolean(token.value))

  async function login(organization_slug: string, email: string, password: string): Promise<void> {
    const value = await api<VisitorSession>('/api/v1/portal/auth/login', {
      method: 'POST', body: JSON.stringify({ organization_slug, email, password }),
    })
    token.value = value.access_token
    session.value = value
    localStorage.setItem(TOKEN_KEY, value.access_token)
  }

  function request<T>(path: string, options: RequestInit = {}): Promise<T> {
    return api<T>(path, options, token.value)
  }

  async function bootstrap(): Promise<boolean> {
    if (!token.value) return false
    try {
      await request('/api/v1/portal/me')
      return true
    } catch {
      logout()
      return false
    }
  }

  function logout(): void {
    token.value = ''
    session.value = null
    localStorage.removeItem(TOKEN_KEY)
  }

  return { token, session, isAuthenticated, login, request, bootstrap, logout }
})
